import Configuration from "./Configuration/Configuration";
import Colors from "./Colors/Colors";

import Mountings from "./Windows/Mountings";
import ProductSize from "./ProductSize/ProductSize";
import {
  WIDTH_ID,
  WIDTH,
  MIN_WIDTH,
  MAX_WIDTH,
  HEIGHT_ID,
  HEIGHT,
  MIN_HEIGHT,
  MAX_HEIGHT,
  setProductSize,
  setWallSize,
} from "./Scene/Window/Scene";

function UserInterfaceWindow(props) {
  const config = {
    WIDTH_ID,
    WIDTH,
    MIN_WIDTH,
    MAX_WIDTH,
    HEIGHT_ID,
    HEIGHT,
    MIN_HEIGHT,
    MAX_HEIGHT,
    setProductSize,
    setWallSize,
  };

  return (
    <>
      <Configuration />
      <Colors />
      <ProductSize config={config} />
      <Mountings />
    </>
  );
}

export default UserInterfaceWindow;
